
export  const accordionData = [
    
  {

    title: 'How to change loan type',
    content: `Submergence, when you are deep under water it’s called
          submergence. It is a beautiful experience when equipped 
          with the right instruments, but very dreadful without it.`
  },

  {
    title: 'How to change BVN',
    content: `Submergence, when you are deep under water it’s called
          submergence. It is a beautiful experience when equipped 
          with the right instruments, but very dreadful without it.`

  },

  {
    title: 'Where to find account',
    content: `Submergence, when you are deep under water it’s called
          submergence. It is a beautiful experience when equipped 
          with the right instruments, but very dreadful without it.`
  },  
  
  {
    title: 'How to pay loan back',
    content: `Submergence, when you are deep under water it’s called
          submergence. It is a beautiful experience when equipped 
          with the right instruments, but very dreadful without it.`
  },

  {
    title: 'How to edit Profile',
    content: `Submergence, when you are deep under water it’s called
          submergence. It is a beautiful experience when equipped 
          with the right instruments, but very dreadful without it.`
  }



];
